export default __webpack_public_path__ + "static/media/logo3.0aa3cb8b.jpg";